// App 實際使用的 4 個 canonical locale
export const APP_LOCALES = ["zh-TW", "zh-CN", "en-US", "en-GB"];

// 把外部（官網導流 ?lang= / localStorage）傳入的語系碼正規化成 canonical locale。
//   接受短碼、大小寫、底線：tw/cn/en/uk、zh_tw、EN-US…等都吃。
//   未知碼回 null（呼叫端自行 fallback，不亂套）。
export function normalizeLang(raw) {
  if (!raw) return null;
  const v = String(raw).trim().toLowerCase().replace(/_/g, "-");
  const MAP = {
    tw: "zh-TW", zh: "zh-TW", "zh-tw": "zh-TW", "zh-hant": "zh-TW", "zh-hant-tw": "zh-TW",
    cn: "zh-CN", "zh-cn": "zh-CN", "zh-hans": "zh-CN", "zh-hans-cn": "zh-CN",
    en: "en-US", us: "en-US", "en-us": "en-US",
    uk: "en-GB", gb: "en-GB", "en-gb": "en-GB",
  };
  return MAP[v] || null;
}

export function getLangPack(type, packs) {
    if (type === 'zh-TW') return packs.TW;
    if (type === 'zh-CN') return packs.CN;
    if (type === 'en-GB') return packs.EN_GB || packs.EN || packs.EN_US;
    if (type === 'en-US' || type === 'en') return packs.EN_US || packs.EN;
    return packs.EN_US || packs.EN || packs.TW;
}